import React from "react";
import PropTypes from "prop-types";
import { CDropDown, CFontIcon } from "@appcues/component-library";

const ThemeFontDropdownOption = props => {
  const {
    data: { type, url },
    selectProps: { onAddFont, onEditTypekitId, onDelete },
    isSelected
  } = props;
  switch (type) {
    case "google": {
      const { children, ...restProps } = props;
      return (
        <CDropDown.Option {...restProps}>
          {children}
          {!isSelected && (
            <CFontIcon
              float="right"
              className="fas fa-trash-alt"
              onClick={e => {
                e.stopPropagation();
                onDelete(url);
              }}
            />
          )}
        </CDropDown.Option>
      );
    }
    case "adobe": {
      const { children, ...restProps } = props;
      return (
        <CDropDown.Option {...restProps}>
          {children}
          <CFontIcon
            float="right"
            className="fas fa-edit"
            onClick={e => {
              e.stopPropagation();
              onEditTypekitId();
            }}
          />
        </CDropDown.Option>
      );
    }
    case "addGoogleFont":
      return (
        <CDropDown.Option
          {...{
            ...props,
            innerProps: {
              ...props.innerProps,
              onClick: onAddFont
            }
          }}
        >
          <CFontIcon marginRight={5} className="fas fa-plus" />
          Add Google Font
        </CDropDown.Option>
      );
    case "addAdobeFont":
      return (
        <CDropDown.Option
          {...{
            ...props,
            innerProps: {
              ...props.innerProps,
              onClick: e => {
                e.stopPropagation();
                onEditTypekitId();
              }
            }
          }}
        >
          <CFontIcon marginRight={5} className="fas fa-plus" />
          Add Adobe Font
        </CDropDown.Option>
      );
    default:
      return <CDropDown.Option {...props} />;
  }
};

ThemeFontDropdownOption.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    type: PropTypes.oneOf(["google", "adobe", "addGoogleFont", "addAdobeFont"]),
    createFont: PropTypes.bool
  }),
  children: PropTypes.func,
  innerProps: PropTypes.object
};

export default ThemeFontDropdownOption;
